import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  Input,
  ContentChild,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'progress-bar',
  styleUrls: ['./progress-bar.component.css'],
  templateUrl: './progress-bar.component.html',
})
export class ProgressBarComponent implements OnInit {
  private itemWidth: string = 'auto';
  @ContentChild('titleTemplate') titleTemplate: TemplateRef<any>;
  @ContentChild('lineTemplate') lineTemplate: TemplateRef<any>;
  @ContentChild('dateTemplate') dateTemplate: TemplateRef<any>;
  @Output() currentStepChange: EventEmitter<number>;
  private _currentStep: number = -1;
  @Input('currentStep')
  public set currentStep(value: number) {
    this._currentStep = value;
    this.currentStepChange.emit(value);
  }
  public get currentStep(): number {
    return this._currentStep;
  }

  @Output() stepsChange: EventEmitter<any[]>;
  private _steps: any[];
  @Input('steps')
  public set steps(value: any[]) {
    this._steps = value;
    if (value != null && value.length > 0) {
      this.itemWidth = 100 / value.length + '%';
    } else {
      this.itemWidth = 'auto';
    }
    this.stepsChange.emit(value);
  }
  public get steps(): any[] {
    return this._steps;
  }

  constructor() {
    this.currentStepChange = new EventEmitter<number>();
    this.stepsChange = new EventEmitter<any[]>();
  }

  ngOnInit() {}
}
